import { Application } from "@hotwired/stimulus"
import Dropdown from "@stimulus-components/dropdown"
import Lightbox from "./lightbox_controller"
import MenuFilter from "./menu_filter_controller"

// Registered by hand rather than through `import.meta.glob`, which is what the other two Stimulus
// apps do: the point of this one is that the public menu ships the controllers named here and no
// others, and a glob is the kind of thing that quietly grows one more.
const application = Application.start()

application.register("dropdown", Dropdown)
application.register("lightbox", Lightbox)
application.register("menu-filter", MenuFilter)
